export function indicatesStorageFull(err: any): boolean {
    return err instanceof DOMException
        && (err.code === 22
            || err.code === 1014
            || err.message.toLowerCase().includes("exceeded")
            || err.name === "QuotaExceededError"
            || err.name === "NS_ERROR_DOM_QUOTA_REACHED");
}